// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jg_a bhg_a bhg_j bhg_q bhg_st bhg_su bhg_w"};